export const COMPONENT_NAME = 'Overlay';

export const OVERLAY_CLASS = 'container-conteudo__overlay';

export const OVERLAY_SELECTOR = `.${OVERLAY_CLASS}`;
export const CONTAINER_CONTENT_SELECTOR = '.container-conteudo';
